import { EditOutlined, DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type PromoCodeModuleSpecsFragment } from '../../../../api/fragments/PromoCodeModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdatePromoCodeModuleDrawer } from './UpdatePromoCodeModuleDrawer';

export type PromoCodeModuleActionsProps = {
    module: PromoCodeModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const PromoCodeModuleActions = ({ module, permissions }: PromoCodeModuleActionsProps) => {
    const { t } = useTranslation(['promoCodeModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const updatePromoCodeModuleDrawer = useUpdatePromoCodeModuleDrawer(module);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('promoCodeModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updatePromoCodeModuleDrawer.open,
        },
        hasDeletePermission && {
            label: t('promoCodeModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('promoCodeModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updatePromoCodeModuleDrawer.render()}
        </>
    );
};

export default PromoCodeModuleActions;
